import { render } from "./moudle3.vue?vue&type=template&id=0f3a62f7&ts=true"
import script from "./moudle3.vue?vue&type=script&lang=ts"
export * from "./moudle3.vue?vue&type=script&lang=ts"

import "./moudle3.vue?vue&type=style&index=0&id=0f3a62f7&lang=scss&scope=true"

import exportComponent from "/Users/haoxunming/Desktop/flowbox公司项目/flowbox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__